<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <button @click="add()" class="btn btn-primary text-uppercase mb-2">
        <small>Add</small>
      </button>

      <button @click="pagesList = pages" class="btn btn-secondary text-uppercase mb-2">
        <small>All</small>
      </button>

      <button
        @click="filter(row.id)"
        v-for="row in userRoles"
        :key="row.id"
        class="btn btn-secondary text-uppercase mb-2"
      >
        <small>{{row.role}}</small>
      </button>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="card">
        <div class="card-body">
          <table class="table table-bordered">
            <tr>
              <th>Name</th>
              <th>Url</th>
              <th>Icon</th>
              <th>Roles</th>
              <th></th>
            </tr>
            <tr v-for="row in pagesList" :key="row.id">
              <td>{{ row.name }}</td>
              <td>{{ row.url }}</td>
              <td>{{ row.icon }}</td>
              <td>{{ row.role }}</td>
              <th>
                <span @click="initEdit(row)" class="badge badge-primary pointer">Edit</span>
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.add" modal-classes="modal-dialog-centered modal-lg">
      <div>
        <div class="content">
          <h3>Add/edit page</h3>
          <form action @submit.prevent="submit">
            <div class="row mb-3">
              <div class="col">
                <label for>Name</label>
                <input required type="text" v-model="form.name" class="form-control" />
              </div>
              <div class="col">
                <label for>URL</label>
                <input required type="text" v-model="form.url" class="form-control" />
              </div>
              <div class="col">
                <label for>Icon</label>
                <input required type="text" v-model="form.icon" class="form-control" />
              </div>
            </div>
            <div class="mb-3">
              <h5>Roles</h5>
              <div v-for="role in userRoles" :key="role.id">
                <label>
                  <input type="checkbox" :value="role.id" v-model="form.roles" />
                  {{ role.role }}
                </label>
              </div>
            </div>
            <button class="btn btn-primary" type="submit">Submit</button>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modals: {
        add: false
      },
      form: {},
      userRoles: [],
      pages: [],
      pagesList: [],
      mode: 1
    };
  },
  mounted() {
    this.init();
    this.getRoles();
    this.initForm();
  },
  methods: {
    init() {
      axios.get("/pages").then(res => {
        this.pages = res.data.data;
        this.pagesList = this.pages;
      });
    },
    initEdit(row) {
      this.form = row;
      this.mode = 2;
      this.modals.add = true;
    },
    submit(e) {
      e.preventDefault();
      this.saving();
      if (this.mode == 1) {
        axios.post("/pages", this.form).then(res => {
          this.init();
          this.modals.add = false;
          this.saved();
        });
      }
      if (this.mode == 2) {
        axios.put("/pages/" + this.form.id, this.form).then(res => {
          this.init();
          this.modals.add = false;
          this.saved();
        });
      }
    },
    add() {
      this.initForm();
      this.modals.add = true;
    },
    getRoles() {
      axios.get("/roles").then(res => {
        this.userRoles = res.data.data;
      });
    },
    initForm() {
      this.form = {
        name: "",
        url: "",
        roles: [],
        icon: ""
      };
    },
    filter(roleId) {
      let roles = [];
      this.pages.forEach(el => {
        if (el.roles.includes(roleId)) {
          roles.push(el);
        }
      });
      this.pagesList = roles;
    }
  }
};
</script>